// components/bill-list/component
/* global DEBUG */

import template  from './component.jade'

import Store     from 'Store'
import parseTime from 'lib/filters/parseUnixTime'
import billLink  from 'lib/filters/parseBillLink'
import cntLinks  from 'lib/filters/parseCntLinks'
import onClick   from 'lib/methods/onClick'

var name = 'bill-list'
var url = '/api/BillList'

const store = new Store(name)

export default {

  name: name,
  template: template(),
  props: ['table', 'title'],
  mixins: [parseTime, billLink, cntLinks, onClick],

  data: () => ({
    name: name,
    url: url,
  }),

  events: {
    // при изменении дат, запросим список счетов
    ['dates:' + name]: function (data) {
      var {number: number} = data
      this.$set('number', number)

      this.$set('data', null)
      this.$set('data', data)
      this.$set('data', store.$get(this))

      return false
    },
    // при изменении строки поиска, запросим счет
    ['number:' + name]: function (data) {
      data.name = 'bill-info'
      this.$dispatch('number', data)

      return false
    },
  },

  computed: {
    table() {
      var table = this.data.table
      if (!this.number) return table

      // если задан номер контейнера, то отсортируем таблицу
      var regexp = new RegExp(this.number)
      return table.filter( item => item.comment.search(regexp) != -1 )
    },
  },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/bill-list/component.js
 **/